import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { RESONANCE_SORT } from '../constants';

const useResonanceMessagesLinkSort = () => {
  const { t } = useTranslation('resonance');

  return useMemo(
    () => [
      {
        label: t('total'),
        value: RESONANCE_SORT.TOTAL,
        getSortValue: (message) => message.filteredAccurateTotal,
      },
      {
        label: 'R1',
        value: RESONANCE_SORT.R1,
        getSortValue: (message) => message.filteredAccurateR1,
      },
      {
        label: 'R2',
        value: RESONANCE_SORT.R2,
        getSortValue: (message) => message.filteredAccurateR2,
      },
    ],
    [t],
  );
};

export default useResonanceMessagesLinkSort;
